<template>
  <div class="bg-background-light dark:bg-background-dark font-display">
    <div
      class="relative flex min-h-screen w-full flex-col items-center justify-center p-6 overflow-hidden"
    >
      <!-- Background Decoration -->
      <div class="absolute inset-0 geometric-bg opacity-50 z-0"></div>
      <div
        class="absolute top-[-10%] right-[-10%] w-64 h-64 bg-primary/10 rounded-full blur-3xl"
      ></div>
      <div
        class="absolute bottom-[-5%] left-[-10%] w-80 h-80 bg-navy-deep/5 rounded-full blur-3xl"
      ></div>
      <img
        src="../assets/complogo.png"
        class="absolute top-6 items-center w-32 z-0"
      />
      <!-- Main Content Container -->
      <div
        class="relative z-10 w-full max-w-[400px] flex flex-col items-center"
      >
        <!-- Logo Section -->
        <!-- <div class="mb-10 flex flex-col items-center">
                    <div
                        class="w-10 h-10 bg-primary rounded-xl flex items-center justify-center shadow-lg shadow-primary/20 mb-4">
                        <span class="material-symbols-outlined text-white text-2xl">calendar_today</span>
                    </div>
                    <h1 class="text-navy-deep dark:text-white text-3xl font-bold tracking-tight">Attendance </h1>
                </div> -->
        <!-- Login Card -->
        <div
          class="w-full bg-white dark:bg-navy-deep/40 backdrop-blur-sm p-6 rounded-xl shadow-sm border border-navy-deep/5 dark:border-white/10"
        >
          <div class="mb-2">
            <h2 class="text-navy-deep dark:text-white text-xl font-semibold">
              Welcome Back
            </h2>
            <p class="text-navy-deep/60 dark:text-gray-400 text-sm">
              Please sign in to your employee account
            </p>
          </div>
          <form class="space-y-5">
            <span
              class="bg-red-100 border border-red-400 text-red-700 px-2 py-1 rounded relative"
              role="alert"
              v-if="err"
            >
              <strong class="font-bold">{{ errmsg }}</strong>
            </span>

            <!-- Employee ID Field -->
            <div class="flex flex-col gap-2">
              <label
                class="text-navy-deep dark:text-gray-300 text-sm font-medium"
                >Employee ID</label
              >
              <div class="relative group">
                <div
                  class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none"
                >
                  <span
                    class="material-symbols-outlined text-navy-deep/40 dark:text-gray-500 group-focus-within:text-primary transition-colors"
                    >badge</span
                  >
                </div>
                <input
                  class="w-full h-12 pl-12 pr-4 rounded-lg border border-navy-deep/10 dark:border-white/10 bg-background-light dark:bg-background-dark/50 text-navy-deep dark:text-white placeholder:text-navy-deep/30 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                  placeholder="Enter your ID"
                  type="text"
                  v-model="uname"
                  maxlength="20"
                  autocomplete="off"
                />
              </div>
            </div>
            <!-- Password Field -->
            <div class="flex flex-col gap-2">
              <div class="flex justify-between items-center">
                <label
                  class="text-navy-deep dark:text-gray-300 text-sm font-medium"
                  >Password</label
                >
              </div>
              <div class="relative group">
                <div
                  class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none"
                >
                  <span
                    class="material-symbols-outlined text-navy-deep/40 dark:text-gray-500 group-focus-within:text-primary transition-colors"
                    >lock</span
                  >
                </div>
                <input
                  class="w-full h-12 pl-12 pr-12 rounded-lg border border-navy-deep/10 dark:border-white/10 bg-background-light dark:bg-background-dark/50 text-navy-deep dark:text-white placeholder:text-navy-deep/30 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                  placeholder="••••••••"
                  :type="showpass ? 'text' : 'password'"
                  v-on:keydown.enter="login()"
                  v-model="upass"
                  maxlength="20"
                  autocomplete="off"
                />
                <div
                  class="absolute inset-y-0 right-0 pr-4 flex items-center cursor-pointer"
                  @click="showpass = !showpass"
                >
                  <span
                    class="material-symbols-outlined text-navy-deep/40 dark:text-gray-500 hover:text-navy-deep transition-colors"
                    >{{ showpass ? "visibility_off" : "visibility" }}</span
                  >
                </div>
              </div>
            </div>
            <!-- Login Button -->
            <button
              class="w-full bg-primary hover:bg-primary/90 text-white font-semibold h-13 py-3.5 rounded-lg shadow-lg shadow-primary/25 transition-all active:scale-[0.98] mt-2 flex items-center justify-center gap-2"
              type="button"
              @click="login()"
              v-show="!isChecking"
            >
              <span>Sign In</span>
              <span class="material-symbols-outlined text-[20px]">login</span>
            </button>
            <button
              class="w-full bg-primary hover:bg-primary/90 text-white font-semibold h-13 py-3.5 rounded-lg shadow-lg shadow-primary/25 transition-all active:scale-[0.98] mt-2 flex items-center justify-center gap-2 disabled:cursor-not-allowed disabled:bg-primary/50 disabled:shadow-none"
              type="button"
              v-show="isChecking"
              disabled
            >
              <span>Authenticating</span>
              <span class="material-symbols-outlined spinner">
                progress_activity
              </span>
            </button>
          </form>
        </div>
        <!-- Footer Info -->
        <div class="mt-8 flex flex-col items-center gap-1">
          <p class="text-navy-deep/40 dark:text-gray-500 text-xs">
            Need technical assistance?
            <a
              class="text-primary font-medium"
              href="mailto:kvrtech323@gmail.com"
              >Contact IT Support</a
            >
          </p>
          <p
            class="text-navy-deep/30 dark:text-gray-600 text-[10px] tracking-widest uppercase mt-4"
          >
            Version {{ $store.state.version }} • KVR Technologies
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "LoginForm",
  emits: ["login-btn"],
  data() {
    return {
      uname: "",
      upass: "",
      err: false,
      errmsg: "",
      errclass: "",
      isChecking: false,
      showpass: false,
      pageName: "empusers.php",
    };
  },
  mounted() {
    const authtoken = this.$route.query.authtoken;
    if (authtoken) {
      this.autoLoginWithToken(authtoken);
    }
  },
  methods: {
    async autoLoginWithToken(authtoken) {
      this.isChecking = true;
      this.err = false;
      try {
        const resp = await axios.post(this.pageName, {
          optn: "CheckAuthToken",
          authtoken: authtoken,
        });
        const response = resp.data;
        this.isChecking = false;
        if (
          response.Errorsts === false &&
          response.List &&
          response.List.length > 0
        ) {
          var Listdata = response.List[0];
          localStorage.setItem("Auth", "Y");
          localStorage.setItem("AuthToken", authtoken);
          localStorage.setItem("UserObj", JSON.stringify(Listdata));
          this.$store.state.userObj = Listdata;
          this.$store.state.isAuthenticated = true;
          this.$store.state.tokenLogin = true;
          this.$store.state.authToken = authtoken;
          this.$router.push("/attendance");
        } else {
          this.err = true;
          this.errmsg = "Invalid or expired auth token!";
        }
      } catch (e) {
        this.isChecking = false;
        this.err = true;
        this.errmsg = "Auto-login failed. Please login manually.";
      }
    },
    async login() {
      this.uname = this.uname.toUpperCase();
      this.upass = this.upass.toUpperCase();
      if (this.uname != "" && this.upass != "") {
        this.isChecking = true;
        this.err = false;
        this.errclass = "warnmsg";
        this.errmsg = "Authenticating...";
        var response;
        await axios
          .post(this.pageName, {
            optn: "CheckUser",
            uname: this.uname,
            upass: this.upass,
          })
          .then(function (resp) {
            response = resp.data;
          });
        this.isChecking = false;
        if (response.Errorsts === false) {
          if (response.List.length > 0) {
            this.errclass = "donemsg";
            this.errmsg = "Welcome!" + this.uname;
            var Listdata = response.List[0];
            localStorage.setItem("Auth", "Y");
            localStorage.setItem("UserObj", JSON.stringify(Listdata));
            localStorage.setItem("FaceRegister", Listdata.face_register);
            this.$store.state.faceRegister = Listdata.face_register;
            this.$store.state.userObj = Listdata;
            this.$store.state.isAuthenticated = true;
            // if (this.$store.state.faceRegister === "N") {
            //   this.$router.push("/registerface");
            // } else {
            this.$router.push("/attendance");
            // }
          } else {
            this.err = true;
            this.errclass = "dangermsg";
            this.errmsg = "Invalid Username/Password!";
          }
        } else {
          this.err = true;
          this.errclass = "dangermsg";
          this.errmsg = "Unable to Login! Something Went Wrong!";
          console.log(response.ErrorMsg);
        }
      } else {
        this.err = true;
        this.errmsg = "Please Fill User Name/Password!";
        this.errclass = "dangermsg";
      }
    },
    nextBox(ele) {
      const currentIndex = Array.from(ele.form.elements).indexOf(ele);
      ele.form.elements
        .item(
          currentIndex < ele.form.elements.length - 1 ? currentIndex + 1 : 0,
          // currentIndex + 1
        )
        .focus();
    },
    async loginLog() {
      await axios
        .post("deliveryboy.php", {
          optn: "Login",
          outletid: this.$store.state.outletId,
          uid: this.$store.state.userId,
          uname: this.$store.state.userName,
        })
        .then(() => {
          // console.log(resp);
        });
    },
  },
};
</script>

<style>
.geometric-bg {
  background-color: #ffffff;
  background-image: radial-gradient(#137fec15 0.5px, transparent 0.5px),
    radial-gradient(#137fec15 0.5px, #ffffff 0.5px);
  background-size: 20px 20px;
  background-position: 0 0, 10px 10px;
}

.spinner {
  animation: spin 1s linear infinite;
  /* Apply spin animation */
}

/* Spin animation keyframes */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
